// mds-dojo — FAITHFUL port of dojox/widget/_CalendarYearView (dojo 1.x). declare from declare-runtime;
// dojo/text!./Calendar/X.html → import ?raw. Upgrades the earlier deliberate STUB to a full port.
import declare from '../../dojo/_base/declare-runtime';
import _CalendarView from './_CalendarView';
import _TemplatedMixin from '../../dijit/_TemplatedMixin';
import dojoDate from '../../dojo/date';
import domClass from '../../dojo/dom-class';
import event from '../../dojo/_base/event';
import template from './Calendar/CalendarYear.html?raw';
import _CalendarMonthYearView from './_CalendarMonthYearView';
export default declare("dojox.widget._CalendarYearView", [_CalendarView, _TemplatedMixin], {
		// summary:
		//		A Calendar view listing 12 years

		// templateString: String
		//		The template to be used to construct the widget.
		templateString: template,

		displayedYears: 6,

		postCreate: function(){
			// summary:
			//		Constructs the view
			this.cloneClass(".dojoxCalendarYearTemplate", 3);
			this.cloneClass(".dojoxCalendarYearGroupTemplate", 2);
			this._populateYears();
			this.addFx(".dojoxCalendarYearLabel", this.domNode);
		},

		_setValueAttr: function(value){
			this._populateYears(value.getFullYear());
		},

		_populateYears: _CalendarMonthYearView.prototype._populateYears,

		adjustDate: function(date, amount){
			// summary:
			//		Adjusts the value of a date. It moves it by 12 years each time.
			return dojoDate.add(date, "year", amount * 12);
		},

		onClick: function(evt){
			// summary:
			//		Handles clicks on year values.
			if(!domClass.contains(evt.target, "dojoxCalendarYearLabel")){event.stop(evt); return;}
			var year = Number(evt.target.innerHTML);
			var date = this.get("value");
			date.setYear(year);
			this.onValueSelected(date, year);
		}
	});
